// extracted by mini-css-extract-plugin
module.exports = {"loaderContainer":"Loader_loaderContainer__21wZn","loader":"Loader_loader__uJjRw","spin":"Loader_spin__3KJML"};